import Tooltip from "../../../../components/tooltip";
import SimulationPortfolio from "./Generation/SimulationSguPortfolio";
import SimulationSummaryAnalysis from "./Generation/SimulationSummaryChart";
import GenerationAnalysis from "./Generation/SimulationGeneration";
import SimulationHeader from "./SimulationHeader";
import { useState } from "react";
import { useOptimizerNavigation } from "../useOptimizerNavigation";
import MainHeader from "../DateSession";
import { ErrorPopup } from "../../../../components/ErrorHandling";
import BlockRangeSelector from "../../../../components/BlockRangeSelector/BlockRangeSelector";
import { Download } from "lucide-react";
import {
  OptimizerCurrentUpdateData,
  OptimizerGnaProceed,
} from "../../../../Rest_api/DemoRestApi";
import DateRangeSelector from "../DateRange/DateRangeSelector";
import { SearchBox } from "../../../../components/Search";
import { useSelector } from "react-redux";
import { start } from "repl";
import Loading from "../../../../components/Loading";
import * as XLSX from "xlsx";
export default function RuvnlSimulationIndex() {
  const { navigateToPage } = useOptimizerNavigation();
  const [error, setError] = useState<string | null>(null);
  const [open, setOpen] = useState(true);
  const [refreshKey, setRefreshKey] = useState(0);
  const [selectedBlock, setSelectedBlock] = useState<any[]>([]);
  const [uniqueTargetDate, setUniqueTargetDate] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
   const [data, setData] = useState([]);

  const preSelectedstartDate = useSelector(
    (state: any) => state.OptimizerDemoDate.startDate
  );
    const preSelectedendDate = useSelector(
      (state: any) => state.OptimizerDemoDate.endDate
    );
  const [selectedTargetDate, setSelectedTargetDate] = useState<
    Array<{ value: string; label: string; isFixed: boolean }>
  >([]);
  const handleDateChange = (
    start: Date | null,
    end: Date | null,
    allDates: Array<{ value: string; label: string; isFixed: boolean }>
  ) => {
    setSelectedTargetDate(allDates);
  };
  const GotoOptimisation = async () => {
    setLoading(true);
    try {
      // const res = await OptimizerCurrentUpdateData(optimizerCurrent);
      const res = await OptimizerGnaProceed();
      if (res) {
        navigateToPage("optimisation");
      }
      setRefreshKey((prev: number) => prev + 1);
    } catch (error) {
      console.error("Error submitting data", error);
      setError("Error submitting data");
    } finally {
      setLoading(false);
    }
  };

  const downloadTable = () => {
      const dowloaddata = data;
      const formattedData = dowloaddata.map((item: any) => ({
        Date: item.date,
        "Time Slot": item.slot,
        "Demand (MW)": item.demand,
        "SGU (MW)": item.sgu,
        "Intra State Renewable (MW)": item.re,
        "Intra state Outage (MW)": item.outage,
        "ISGS (MW)": item.isgs,
        "Maximum GNA Requirement (MW)": item.oar,
      }));
  
      // Create worksheet
      const worksheet = XLSX.utils.json_to_sheet(formattedData);
  
      // Create workbook
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Generation Portfolio");
  
      // Download Excel file
      XLSX.writeFile(workbook, "Generation Portfolio.xlsx");
    };
  return (
    <>
      <div className="w-full">
        {loading && <Loading />}
        <MainHeader />
        <div className="h-[calc(-85px+100vh)] p-4">
          <div className="w-full h-full flex flex-col gap-4">
            <SimulationHeader
              title="Generation Portfolio"
              refreshKey={refreshKey}
              setRefreshKey={setRefreshKey}
            />
            <div className=" flex flex-row gap-4 relative">
              <SimulationPortfolio
                open={open}
                setOpen={setOpen}
                setError={setError}
                refreshKey={refreshKey}
                setRefreshKey={setRefreshKey}
              />

              <div
                className="gas-chart-container !p-2 bg-white shadow-[rgba(149,157,165,0.2)_0px_8px_24px] rounded-2xl"
                style={{
                  height: "calc(-195px + 100vh)",
                  width: "80%",
                }}
              >
                <div className="flex justify-between items-center mb-1 border-b border-[#DFEAF2] pb-2">
                  {" "}
                  <div className="flex items-center gap-3">
                    {/* <BlockRangeSelector
                      blocks={Array.from({ length: 96 }, (_, i) => i + 1)}
                      placeholder="Select Date Range"
                      selectedOptions={selectedBlock.map((item) => item.value)}
                      setSelectedOptions={setSelectedBlock}
                    /> */}
                    {/* <SearchBox
                      options={uniqueTargetDate.map((item) => ({
                        value: item,
                        label: item,
                      }))}
                      isMany={true}
                      placeholder="Select Date"
                      selectedOptions={selectedTargetDate}
                      onChange={setSelectedTargetDate}
                    /> */}
                    <DateRangeSelector
                      placeholder="Select Date Range"
                      startDate={preSelectedstartDate}
                      endDate={preSelectedendDate}
                      onDateChange={handleDateChange}
                    />
                  </div>
                  <div className="flex gap-x-6 justify-end">
                    <button
                      onClick={downloadTable}
                      className="flex items-center gap-2 p-2 text-sm rounded-xl bg-[#FFFAF6] text-[#F1935C] font-medium border border-[#F1935C]"
                    >
                      <span>Download Data</span>
                      <Download className="w-5 h-5" />
                    </button>
                    <button
                      // disabled={isAcceptDisabled()}
                      onClick={GotoOptimisation}
                      className="flex items-center gap-2 p-3 text-sm rounded-xl disabled:text-[#A9A8B1] disabled:bg-[#E2E2E5] bg-[#F1935C] text-white font-medium"
                    >
                      {loading ? "Processing..." : "Proceed to Optimisation"}
                    </button>
                  </div>
                </div>
                <div className="load-data grid grid-cols-2 p-0 md:grid-cols-12 grid-rows-full md:grid-rows-2 gap-2 h-full w-full md:overflow-hidden rounded-2xl !shadow-[rgba(149,157,165,0.2)_0px_8px_24px]">
                  <SimulationSummaryAnalysis
                    selectedBlock={selectedBlock}
                    refreshKey={refreshKey}
                    setError={setError}
                    setUniqueTargetDate={setUniqueTargetDate}
                    selectedTargetDate={selectedTargetDate}
                    data={data}
                    setData={setData}
                  />
                  <div className="col-span-1 md:col-span-12 w-full !h-[100%]">
                    <GenerationAnalysis
                      selectedBlock={selectedBlock}
                      refreshKey={refreshKey}
                      setError={setError}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ErrorPopup error={error} onClose={() => setError(null)} />
        <div className="gna-footer-container">
          <div className="grid grid-cols-3 justify-between gap-5 ">
            <Tooltip
              note={
                <p>
                  {/* Default values and variable charges are auto-fetched from
                  system. */}
                </p>
              }
              text=""
            >
              <p className="gna-footer-text">Source</p>
            </Tooltip>
            <p className="gna-footer-text col-span-1 text-center">
              Powered by <strong>GNA Energy</strong>
            </p>
            <strong className="gna-footer-text col-span-1 text-end">
              Beta Version
            </strong>
          </div>
        </div>
      </div>
    </>
  );
}
